module.exports = __webpack_public_path__ + "img/flash.cde55726.svg";